export default "<app-root>\r\n</app-root>\r\n"